import React from 'react';
import { aiCards } from '../data';
import './AISection.css';

export default function AISection() {
  return (
    <section className="ai-section" id="ai-section">
      <div className="ai-grid">
        <div className="ai-body">
          <p className="ai-label">AI & The Future of Work</p>
          <h2 className="ai-title">Will AI <span>Replace</span> Your Job?</h2>
          <p>Artificial Intelligence is reshaping the global job market at an unprecedented pace. From automated customer service to AI-powered code generation, many roles are being redefined and some eliminated.</p>
          <p>But here&apos;s what the headlines miss: <strong>AI creates more opportunities than it removes</strong> for those who prepare.</p>
          <div className="ai-verdict">
            <strong>Our take:</strong> AI won&apos;t replace you. But a person who knows how to use AI will. At Laftek Business Solutions, we help you identify which skills to build right now so you remain in demand, relevant, and ahead of the curve.
          </div>
          <a href="/contact" className="ai-cta">Get Future-Ready Today</a>
        </div>
        <div className="ai-cards">
          {aiCards.map((card) => (
            <div key={card.title} className="ai-card">
              <span className="ai-card-icon">{card.icon}</span>
              <div>
                <div className="ai-card-title">{card.title}</div>
                <div className="ai-card-desc">{card.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
